var _excluded = ["onCloseButtonClick", "closeButtonTitle", "children", "startPosition", "size", "header", "headerType", "headerWidth", "hasSections", "backgroundColor", "headerBackgroundColor", "footerBar", "footer", "footerHorizontalSpace"];
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useCallback, useRef, useState } from "react";
import StopPropagationPageScroll from "../../../helpers/StopPropagationPageScroll";
import useClickOutside from "../../../hooks/useClickOutside";
import useEscClick from "../../../hooks/useEscClick";
import useModalFocus from "../../../hooks/useModalFocus";
import useSwipeOnMobile from "../../../hooks/useSwipeOnMobile";
var ThinX = function ThinX(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14.692 2.795a1.051 1.051 0 1 0-1.487-1.487L8 6.513 2.795 1.308a1.052 1.052 0 0 0-1.487 1.487L6.513 8l-5.205 5.205a1.052 1.052 0 1 0 1.487 1.487L8 9.487l5.205 5.205a1.051 1.051 0 1 0 1.487-1.487L9.487 8l5.205-5.205Z"
  }));
};
ThinX.defaultProps = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import { animationDuration } from "../../../settings";
import ContainerOrg from "../ContainerOrg";
import PortalContainerOrg, { PortalType } from "../PortalContainerOrg";
import { Overlay, StyledOverlayContainerOrg, Header, StyledFlexContainerOrg, StyledContainerOrg, CloseButton, FooterContainer, Content, ContentAndFooterContainer, FooterElement, FooterBarElement } from "./OverlayContainerOrg.styled";

// eslint-disable-next-line no-shadow
export var startPositions = /*#__PURE__*/function (startPositions) {
  startPositions["BOTTOM"] = "bottom";
  startPositions["LEFT"] = "left";
  startPositions["RIGHT"] = "right";
  return startPositions;
}({});

// eslint-disable-next-line no-shadow
export var sizes = /*#__PURE__*/function (sizes) {
  sizes["SMALL"] = "small";
  sizes["MEDIUM"] = "medium";
  sizes["LARGE"] = "large";
  sizes["FULL"] = "full";
  return sizes;
}({});

// eslint-disable-next-line no-shadow
export var headerTypes = /*#__PURE__*/function (headerTypes) {
  headerTypes["SCROLLABLE"] = "scrollable";
  headerTypes["BORDERED"] = "bordered";
  headerTypes["SHADOWED"] = "shadowed";
  return headerTypes;
}({});
var defaultProps = {
  backgroundColor: "backgroundLight",
  startPosition: startPositions.RIGHT,
  size: sizes.SMALL,
  headerType: headerTypes.BORDERED,
  headerBackgroundColor: "backgroundLight"
};
function OverlayContainerOrg(_ref) {
  var onCloseButtonClick = _ref.onCloseButtonClick,
    closeButtonTitle = _ref.closeButtonTitle,
    children = _ref.children,
    _ref$startPosition = _ref.startPosition,
    startPosition = _ref$startPosition === void 0 ? defaultProps.startPosition : _ref$startPosition,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? defaultProps.size : _ref$size,
    header = _ref.header,
    _ref$headerType = _ref.headerType,
    headerType = _ref$headerType === void 0 ? defaultProps.headerType : _ref$headerType,
    headerWidth = _ref.headerWidth,
    hasSections = _ref.hasSections,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? defaultProps.backgroundColor : _ref$backgroundColor,
    _ref$headerBackground = _ref.headerBackgroundColor,
    headerBackgroundColor = _ref$headerBackground === void 0 ? defaultProps.headerBackgroundColor : _ref$headerBackground,
    footerBar = _ref.footerBar,
    footer = _ref.footer,
    footerHorizontalSpace = _ref.footerHorizontalSpace,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasAnimationOnClose = _useState2[0],
    setHasAnimationOnClose = _useState2[1];
  var containerRef = useRef(null);
  var _useModalFocus = useModalFocus(containerRef),
    handleKeyDown = _useModalFocus.handleKeyDown,
    handleFocusOnModalClose = _useModalFocus.handleFocusOnModalClose;
  var handleCloseButtonClick = useCallback(function (event) {
    setHasAnimationOnClose(true);
    setTimeout(function () {
      return onCloseButtonClick(event);
    }, animationDuration["default"]);
    handleFocusOnModalClose();
  }, [onCloseButtonClick]);
  useClickOutside(containerRef, function (event) {
    return handleCloseButtonClick(event);
  });
  useEscClick(containerRef, function (event) {
    return handleCloseButtonClick(event);
  });
  var _useSwipeOnMobile = useSwipeOnMobile(handleCloseButtonClick, startPosition !== startPositions.BOTTOM),
    onTouchStart = _useSwipeOnMobile.onTouchStart,
    onTouchMove = _useSwipeOnMobile.onTouchMove,
    onTouchEnd = _useSwipeOnMobile.onTouchEnd;
  return /*#__PURE__*/React.createElement(PortalContainerOrg, {
    portalType: PortalType.MODAL
  }, /*#__PURE__*/React.createElement(Overlay, restProps, /*#__PURE__*/React.createElement(StyledOverlayContainerOrg, {
    ref: containerRef,
    onKeyDown: handleKeyDown,
    $hasHeader: !!header,
    $startPosition: startPosition,
    $size: size,
    $hasSections: !!hasSections,
    $backgroundColor: backgroundColor,
    $hasAnimationOnClose: hasAnimationOnClose
  }, header && headerType !== headerTypes.SCROLLABLE ? /*#__PURE__*/React.createElement(Header, {
    $backgroundColor: defaultProps.backgroundColor,
    $headerBackgroundColor: headerBackgroundColor,
    $headerType: headerType,
    $startPosition: startPosition,
    onTouchStart: onTouchStart,
    onTouchMove: onTouchMove,
    onTouchEnd: onTouchEnd
  }, /*#__PURE__*/React.createElement(ContainerOrg, {
    width: headerWidth,
    isFullWidth: !headerWidth
  }, /*#__PURE__*/React.createElement(StyledFlexContainerOrg, {
    justifyContent: "space-between",
    alignItems: "center",
    $hasSections: !!hasSections
  }, header))) : null, /*#__PURE__*/React.createElement(StyledContainerOrg, {
    isFullWidth: true,
    $headerType: headerType
  }, /*#__PURE__*/React.createElement(StopPropagationPageScroll, null), /*#__PURE__*/React.createElement(CloseButton, {
    icon: ThinX,
    sizeSpace: 2,
    onClick: handleCloseButtonClick,
    $hasHeader: !!header,
    $startPosition: startPosition,
    $hasSections: !!hasSections,
    title: closeButtonTitle,
    "aria-label": closeButtonTitle
  }), header && headerType === headerTypes.SCROLLABLE ? /*#__PURE__*/React.createElement(Header, {
    $backgroundColor: defaultProps.backgroundColor,
    $headerBackgroundColor: headerBackgroundColor,
    $headerType: headerType,
    $startPosition: startPosition,
    onTouchStart: onTouchStart,
    onTouchMove: onTouchMove,
    onTouchEnd: onTouchEnd
  }, /*#__PURE__*/React.createElement(ContainerOrg, {
    width: headerWidth,
    isFullWidth: !headerWidth
  }, /*#__PURE__*/React.createElement(StyledFlexContainerOrg, {
    justifyContent: "space-between",
    alignItems: "center",
    $hasSections: !!hasSections
  }, header))) : null, /*#__PURE__*/React.createElement(ContentAndFooterContainer, {
    direction: "column",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(ContainerOrg, {
    width: headerWidth,
    isFullWidth: !headerWidth
  }, children)), footer ? /*#__PURE__*/React.createElement(FooterContainer, {
    $backgroundColor: defaultProps.backgroundColor,
    $headerBackgroundColor: headerBackgroundColor,
    $headerType: headerType
  }, footerBar ? /*#__PURE__*/React.createElement(FooterBarElement, null, footerBar) : null, /*#__PURE__*/React.createElement(FooterElement, {
    $footerHorizontalSpace: footerHorizontalSpace
  }, footer)) : null)))));
}
export default OverlayContainerOrg;